import { render } from "./HardSkills.vue?vue&type=template&id=2ab98f24"
import script from "./HardSkills.vue?vue&type=script&lang=js"
export * from "./HardSkills.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Programación\\Desktop\\openbootcamp\\Vuejs\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__